import { render, staticRenderFns } from "./organization-thirdparty-view.vue?vue&type=template&id=cfbdb3d4"
import script from "./organization-thirdparty-view.vue?vue&type=script&lang=js"
export * from "./organization-thirdparty-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports